import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'deviceItem_page',
  props: {
    current: {
      type: Object,
      default: {}
    },
    prev: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '历史记录',
        queryFunName: 'deviceItemLogQuery',
        dicTreeFunName: 'dictionaryCache'
      },
      searchForm: {
        page: 1,
        limit: 10,
        itemName: null,
        deviceId: this.current.id,
        year: dayjs().format('YYYY'),
        sortField: 'ts'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      dicData: {
        typeUpperCode: 'iot_sensor_item',
        configTypes: [],
        configTypeOptions: {}
      },
      valueEnums: {}

      // 导出
      ,
      editDialogShow: false,
      dateValue: [],
      checked: [],
      item_list: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    console.log('history_logs_page this.current', this.current);
    if (this.current.deviceId) {
      this.searchForm.deviceId = this.current.deviceId || '';
      this.searchForm.deviceItemId = this.current.id || '';
    } else {
      this.searchForm.deviceId = this.current.id || '';
    }
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.typeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configTypes = res.data;
          var _iterator = _createForOfIteratorHelper(res.data),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              _this.dicData.configTypeOptions[item.code] = item.name;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api['deviceItemQuery']({
        page: 1,
        limit: 100,
        deviceId: _this.current.id
      }).then(function (res) {
        if (res.data) {
          _this.item_list = [];
          var _iterator2 = _createForOfIteratorHelper(res.data),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              _this.$set(_this.valueEnums, item.typeCode, item.valueEnums && item.valueType == 'Enums' ? JSON.parse(item.valueEnums) : null);
              _this.item_list.push(item);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          console.log('valueEnums', _this.valueEnums, _this.item_list);
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    back: function back() {
      if (this.current.deviceId) {
        this.$emit('child-go', this.prev, 'deviceItem');
      } else {
        this.$emit('child-go-device');
      }
    },
    query: function query() {
      var _this2 = this;
      if (!this.searchForm.year) {
        this.$message.info('请先选择时间！');
        return;
      }
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.current.id, this.searchForm.year, this.searchForm).then(function (res) {
        _this2.tableData = res.data || [];
        _this2.totalCount = res.count;
        _this2.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^ts';
      this.query();
    }
  }
};